import { ManifestValidator } from './lib/ManifestValidator'

var lastUpdateProgress = null
const REFRESH_TIME = 15 * 1000 // 15 seconds

function updateProgressToServer (bookid, providerid, sessionid, fragment, percent, force) {
  if (!force && lastUpdateProgress != null && new Date() - lastUpdateProgress < REFRESH_TIME) { return Promise.resolve(true) }
  let progressServer = window._env_.CHECKPOINT_URL
  lastUpdateProgress = new Date()
  let encodeSessionId = encodeURIComponent(sessionid)
  return window.fetch(`${progressServer}/audio/${providerid}/${bookid}/${encodeSessionId}`, {
    method: 'POST',
    headers: {
      'content-type': 'application/json'
    },
    body: JSON.stringify({
      'ts': fragment,
      'p': percent
    })
  }).then(() => true)
    .catch(() => false)
}

function normalizeCheckpoint (input) {
  if (input === null) { return { ts: "#", p: 0 } }
  try {
    return JSON.parse(input)
  } catch (e) {
    if (e instanceof SyntaxError) {
      return {
        ts: input,
        p: null
      }
    }
    throw e
  }
}

class Checkpoint {
  constructor (input) {
    this.ts = input.ts
    this.p = input.p || 0
  }

  toAudioURI (manifest) {
    return this.ts
  }

  isEarlierThan (other) {
    if(this.p == other.p){
      return +this.ts.split("#")[1] < +other.ts.split("#")[1]
    }
    return this.p < other.p
  }
}

function normalize (manifest) {
  if (!manifest.spine && manifest.readingOrder) {
    manifest.spine = manifest.readingOrder
  }

  return manifest
}

export default {
  // Try to fetch the local manifest if it fail try the remote manifest
  fetchManifest (bookid) {
    let key = `manifest/${bookid}`
    return Promise.resolve(localStorage.getItem(key))
      .then(JSON.parse)
      .then((value) => {
        // Local maninfest is embeded in a timestamped object
        if (value) return new ManifestValidator(normalize(value.manifest)).validated
        throw new Error('Local manifest not found')
      })
      .catch((err) => {
        console.log('Local manifest:', err.message)
        console.log('Fallbacking to remote manifest')
        return this.fetchRemoteManifest(bookid)
      })
  },

  fetchRemoteManifest (bookid) {
    // The bookid is a base-64 encoded URL to the manifest
    let url = atob(decodeURIComponent(bookid).replace(/_/g, '/').replace(/-/g, '+'))

    return window.fetch(url)
      .then((response) => response.json())
      .then((value) => new ManifestValidator(normalize(value)).validated)
  },

  setManifest (bookid, manifest, forceUpdate = false) {
    if (!manifest) return

    let key = `manifest/${bookid}`

    // Dont save manifest if already present unless forceUpdate is true
    if (!forceUpdate && localStorage.getItem(key)) return

    // Create a timestamped object with the manifest for futur use.
    // Ex: Save already present manifest if it's to old
    let timestamped = {
      manifest: manifest,
      timestamp: new Date().getTime()
    }

    // Stringify before storing it to bypass the limitation of
    // localStorage to handle only string key/value pairs.
    // localStorage.setItem(key, JSON.stringify(timestamped))
    this.clearManifests();
    return Promise.resolve(true)
  },

  clearManifests() {
    for(const key of Object.keys(localStorage)) {
      if(key.match(/manifest\//)) {
        localStorage.removeItem(key);
      }
    }
  },

  fetchProgress (bookId, providerid, sessionid) {
    let progressServer = window._env_.CHECKPOINT_URL
    let fetchFromServer
    if (providerid && sessionid) {
      let encodeSessionId = encodeURIComponent(sessionid)
      fetchFromServer = window.fetch(`${progressServer}/audio/${providerid}/${bookId}/${encodeSessionId}`).then((response) => {
        if (!response.ok) {
          throw Error(response.statusText)
        }
        return response
      })
        .then((response) => response.json())
        .then((json) => {
          return new Checkpoint(json)
        })
        .catch((e) => null)
    } else {
      fetchFromServer = Promise.resolve(null)
    }

    let localKey = `progress/${bookId}`
    let localStorageValue = localStorage.getItem(localKey)
    let localCheckpoint = new Checkpoint(normalizeCheckpoint(localStorageValue))

    return fetchFromServer.then(serverCheckpoint => {
      if (serverCheckpoint === null) { return localCheckpoint }
      if (localCheckpoint === null) { return serverCheckpoint }

      if (serverCheckpoint.isEarlierThan(localCheckpoint)) {
        return localCheckpoint
      } else {
        return serverCheckpoint
      }
    })
  },

  setProgress (bookid, providerid, sessionid, fragment, percent, force) {
    let key = `progress/${bookid}`
    localStorage.setItem(key, fragment)
    if (providerid && sessionid) {
      return updateProgressToServer(bookid, providerid, sessionid, fragment, percent, force)
    } else {
      return Promise.resolve(true)
    }
  },

  fetchPlaybackRate () {
    let key = 'playbackRate'
    return Promise.resolve(localStorage.getItem(key))
  },

  setPlaybackRate (value) {
    let key = 'playbackRate'
    localStorage.setItem(key, value)
    return Promise.resolve(true)
  },

  fetchVolume () {
    let key = 'volume'
    return Promise.resolve(localStorage.getItem(key))
  },

  setVolume (value) {
    let key = 'volume'
    localStorage.setItem(key, value)
    return Promise.resolve(true)
  }
}



// WEBPACK FOOTER //
// ./src/api.js